import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { toDateOnlyString } from "../../utils";
import EditSaleForm from "./EditSaleForm";
import MealTypeSelectBox from "./MealTypeSelectBox";

const EditHotelSaleForm = (props) => {
  const { isRefund, onChange, sale, title } = props;

  const ciDate = dayjs(sale?.ciDate);
  const coDate = sale?.coDate ? dayjs(sale?.coDate) : ciDate.add(1, "day");
  const hotel = sale?.hotel || "";
  const loc = sale?.loc || "";
  const meal = sale?.meal || "";
  const pax = sale?.pax || "";
  const pnr = sale?.pnr || "";
  const room = sale?.room || "";

  const minCheckOutDate = ciDate?.add(1, "day");

  const onSaleChange = (changes) => {
    onChange({
      ...sale,
      ciDate: toDateOnlyString(ciDate),
      coDate: toDateOnlyString(coDate),
      ...changes,
    });
  };

  const onCheckInDateChange = (ciDate) => {
    onSaleChange({ ciDate: toDateOnlyString(ciDate) });
  };

  const onCheckOutDateChange = (coDate) => {
    onSaleChange({ coDate: toDateOnlyString(coDate) });
  };

  const onHotelNameChange = (event) => {
    const hotel = event.target.value;
    onSaleChange({ hotel });
  };

  const onLocationChange = (event) => {
    const loc = event.target.value;
    onSaleChange({ loc });
  };

  const onMealChange = (event) => {
    const meal = event.target.value;
    onSaleChange({ meal });
  };

  const onPassengerChange = (event) => {
    const pax = event.target.value;
    onSaleChange({ pax });
  };

  const onPnrChange = (event) => {
    const value = event.target.value;
    if (value === "" || /^[0-9A-Za-z-]{0,50}$/u.test(value)) {
      const pnr = value.toUpperCase();
      onSaleChange({ pnr });
    }
  };

  const onRoomChange = (event) => {
    const room = event.target.value;
    onSaleChange({ room });
  };

  return (
    <EditSaleForm
      isRefund={isRefund}
      onChange={onSaleChange}
      sale={sale}
      subTitle={title}
    >
      <Grid xs={12}>
        <TextField
          autoFocus
          fullWidth
          label="Main Guest Full Name"
          onChange={onPassengerChange}
          required
          value={pax}
        />
      </Grid>
      <Grid xs={12}>
        <TextField
          fullWidth
          label="Booking Confirmation #"
          onChange={onPnrChange}
          value={pnr}
        />
      </Grid>
      <Grid xs={6}>
        <DatePicker
          format="DD-MMM-YYYY"
          label="Check-in"
          onChange={onCheckInDateChange}
          slotProps={{ textField: { fullWidth: true } }}
          value={ciDate}
        />
      </Grid>
      <Grid xs={6}>
        <DatePicker
          format="DD-MMM-YYYY"
          label="Check-out"
          minDate={minCheckOutDate}
          onChange={onCheckOutDateChange}
          slotProps={{ textField: { fullWidth: true } }}
          value={coDate}
        />
      </Grid>
      <Grid xs={12}>
        <TextField
          fullWidth
          label="Hotel Name"
          onChange={onHotelNameChange}
          required
          value={hotel}
        />
      </Grid>
      <Grid xs={12}>
        <TextField
          fullWidth
          label="Location (City, Country)"
          onChange={onLocationChange}
          required
          value={loc}
        />
      </Grid>
      <Grid xs={12}>
        <TextField
          fullWidth
          label="Room Type"
          onChange={onRoomChange}
          value={room}
        />
      </Grid>
      <Grid xs={12}>
        <MealTypeSelectBox onChange={onMealChange} value={meal} />
      </Grid>
    </EditSaleForm>
  );
};

export default EditHotelSaleForm;
